import { gql, useQuery } from '@apollo/client';

export const GET_ACTION_LOG_STATS = gql`
  query GetActionLogStats($startDate: String!, $endDate: String!) {
    actionLogStats(startDate: $startDate, endDate: $endDate)
  }
`;

export interface ActionCount {
  action: string;
  _count: number;
}

export interface UserCount {
  userId: string;
  userEmail: string;
  userName?: string;
  _count: number;
}

export interface AutomatedCount {
  automated: boolean;
  _count: number;
}

export interface ActionLogStats {
  actionCounts: ActionCount[];
  userCounts: UserCount[];
  automatedCounts: AutomatedCount[];
  period: {
    startDate: string;
    endDate: string;
  };
}

export interface GetActionLogStatsResult {
  actionLogStats: ActionLogStats;
}

export interface ActionLogStatsQueryVariables {
  startDate: string;
  endDate: string;
}

export function useActionLogStatsQuery(variables: ActionLogStatsQueryVariables) {
  return useQuery<GetActionLogStatsResult, ActionLogStatsQueryVariables>(GET_ACTION_LOG_STATS, {
    variables,
    fetchPolicy: 'network-only',
  });
}
